/* src/app/modules/dna-syngovia/components/dna-syngovia-empty-state/dna-syngovia-empty-state.component.scss */
:host,
.messages {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}
:host {
  gap: 1.25rem;
  padding: 0 2rem;
  justify-content: center;
}
img {
  width: 2.75rem;
  height: 2.75rem;
}
sh-text {
  width: fit-content;
}
/*# sourceMappingURL=dna-syngovia-empty-state.component.css.map */
